(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const q = s => root.querySelector(s), all = s => [...root.querySelectorAll(s)];
    const launchHold=root.dataset.launchHold==='true';
    const calc=root.querySelector('[data-savings-calculator]');if(calc){const updateCalc=()=>{const n=Math.min(50,Math.max(0,Number(calc.querySelector('[data-rolls]').value)||0)),p=Math.min(100,Math.max(0,Number(calc.querySelector('[data-roll-price]').value)||0));calc.querySelector('[data-annual]').textContent=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(n*p*52)+' / year';};calc.addEventListener('input',updateCalc);updateCalc();}
    const variants = JSON.parse(q('[data-variants]').textContent).variants;
    const find = id => variants.find(v => String(v.id) === String(id));
    const initial = find(root.dataset.selected) || variants.find(v => v.available) || variants[0];
    const route = window.Shopify?.routes?.root || '/';
    const money = n => new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency',currency:root.dataset.currency || 'USD'}).format(n / 100);
    let selection = [initial.id, null, null], quantity = 1, activeSlot = 0, busy = false;
    let expressTarget, expressReady = false, expressQueue = Promise.resolve();
    const saved = history.state?.tenloveFinds;
    if (saved?.version === 2 && saved.product === root.dataset.product && [1,2,3].includes(saved.quantity) && Array.isArray(saved.selection) && saved.selection.length === 3 && saved.selection.every(id => id === null || find(id))) {
      quantity = saved.quantity; selection = [...saved.selection];
      activeSlot = Number.isInteger(saved.activeSlot) && saved.activeSlot >= 0 && saved.activeSlot < quantity ? saved.activeSlot : 0;
      const requested = new URL(location.href).searchParams.get('variant');
      if (requested && find(requested)) selection[0] = find(requested).id;
    }
    const flowerName = v => v.title;
    const off = (_v, qty) => qty < 2 ? 0 : Math.round(Number(qty === 2 ? root.dataset.duoOff : root.dataset.trioOff) * (root.dataset.currency === 'USD' ? 1 : Number(window.Shopify?.currency?.rate || 1)));
    const chosen = () => selection.slice(0, quantity).map(find);
    const missing = () => selection.slice(0, quantity).findIndex(id => !find(id));
    const allowed = () => {
      if(launchHold)return false;
      const counts = new Map();
      for (const v of chosen()) {if (!v?.available) return false; counts.set(v.id,(counts.get(v.id)||0)+1);}
      return chosen().every(v => !v.tracked || v.policy === 'continue' || v.stock >= counts.get(v.id));
    };
    const bundleCode = () => quantity === 3 ? root.dataset.trioCode : quantity === 2 ? root.dataset.duoCode : '';
    const discountCookie = () => {
      const cookie = document.cookie.split('; ').find(value => value.startsWith('discount_code='));
      return cookie ? decodeURIComponent(cookie.slice('discount_code='.length)) : '';
    };
    const prepareExpress = () => {
      const code = bundleCode();
      if (code === expressTarget) return;
      expressTarget = code; expressReady = false;
      // Shopify's wallet reads its native discount cookie. Serialize requests so
      // quick bundle changes cannot leave the previous tier attached to checkout.
      expressQueue = expressQueue.then(async () => {
        if (expressTarget !== code) return;
        try {
          if (code) {
            const response = await fetch(`${route}discount/${code}?redirect=${encodeURIComponent(route+'cart.js')}`, {credentials:'same-origin',signal:AbortSignal.timeout(12000)});
            if (!response.ok) throw Error('Bundle discount could not be prepared');
            await response.json();
          } else if ([root.dataset.duoCode,root.dataset.trioCode].includes(discountCookie())) {
            document.cookie = 'discount_code=; Max-Age=0; Path=/; SameSite=Lax';
          }
          if (expressTarget === code) expressReady = !code || discountCookie() === code;
        } catch (_) {
          if (expressTarget === code) expressReady = false;
        }
        update();
      });
    };
    const syncExpress = () => {
      const counts = new Map();
      for (const item of chosen()) if (item) counts.set(item.id,(counts.get(item.id)||0)+1);
      const [first,...extras] = [...counts].map(([id,quantity])=>({id,quantity}));
      const id = q('[data-express-id]'), count = q('[data-express-quantity]');
      const changed = id.value !== String(first?.id || '') || count.value !== String(first?.quantity || 1);
      id.value = first?.id || ''; count.value = first?.quantity || 1;
      const fields = extras.flatMap((item,index)=>['id','quantity'].map(key=>{
        const input=document.createElement('input');input.type='hidden';
        input.name=`shopify-additional-items[${index+1}][${key}]`;input.value=String(item[key]);return input;
      }));
      q('[data-express-items]').replaceChildren(...fields);
      if (changed) {id.dispatchEvent(new Event('change',{bubbles:true}));count.dispatchEvent(new Event('change',{bubbles:true}));}
    };
    const update = () => {
      const v = find(selection[activeSlot]) || find(selection[0]) || initial;
      const total = chosen().reduce((n,x) => n+Math.max(0,(x || v).price-off(x || v,quantity)),0);
      const counts = new Map();
      for (const item of chosen()) if (item) counts.set(item.id,(counts.get(item.id)||0)+1);
      all('[name="story_variant"]').forEach(input => {
        const item = find(input.value), card = input.closest('label'), count = counts.get(item.id) || 0;
        input.checked=String(input.value)===String(selection[activeSlot]);
        input.disabled=busy||!item.available;
        input.setAttribute('aria-label',flowerName(item)+(item.available?'':' - Sold out')+(quantity>1?', for item '+(activeSlot+1):'')+(count?', '+count+' in your bundle':''));
        card.classList.toggle('is-selected',input.checked);
        card.querySelector('[data-design-count]').hidden=quantity===1||!count;
        card.querySelector('[data-design-count]').textContent='\u00d7'+count;
        card.querySelector('[data-design-count]').setAttribute('aria-hidden','true');
      });
      all('[name="story_bundle"]').forEach(input => {input.checked=Number(input.value)===quantity;input.disabled=busy;input.closest('label').classList.toggle('is-selected',input.checked);});
      all('[data-kit-slot]').forEach(button => {
        const slot=Number(button.dataset.kitSlot)-1, item=find(selection[slot]);
        button.hidden=slot>=quantity;button.disabled=busy;
        button.setAttribute('aria-pressed',String(slot===activeSlot));
        button.setAttribute('aria-label','Item '+(slot+1)+': '+(item?flowerName(item)+'. Change option.':'Choose an option.'));
        button.classList.toggle('is-filled',Boolean(item));
        button.querySelector('[data-kit-image]').hidden=!item;
        if(item)button.querySelector('[data-kit-image]').src=item.image;
        button.querySelector('[data-kit-placeholder]').hidden=Boolean(item);
        button.querySelector('[data-kit-quantity]').hidden=!item;
        button.querySelector('[data-kit-name]').textContent=item?flowerName(item):'Choose an option';
        button.querySelector('[data-kit-action]').textContent=slot===activeSlot?'Choosing below':item?'Tap to change':'Tap to choose';
      });
      q('[data-mix]').hidden=quantity===1;
      q('[data-mix]').dataset.quantity=String(quantity);
      q('[data-picker-title]').textContent=quantity===1?'Choose your favorite':'Choose each option';
      q('[data-selection-progress]').hidden=quantity===1;
      q('[data-selection-progress]').textContent=chosen().filter(Boolean).length+' of '+quantity+' chosen';
      q('[data-color-name]').textContent=find(selection[activeSlot])?flowerName(v):'Choose an option';
      q('[data-editing-slot]').textContent=quantity===1?'':' for item '+(activeSlot+1);
      q('[data-picker-help]').textContent=quantity===1?'Choose your favorite option below.':missing()>=0?find(selection[activeSlot])?'Tap item '+(missing()+1)+' above to choose its option. Matching or mixed, it is up to you.':'Choose an option for item '+(activeSlot+1)+' below. Matching or mixed, it is up to you.':'Your bundle is ready. Tap an item above to change it.';
      q('[data-size-name]').textContent=v.title;
      ['width','depth','height'].forEach((name,i)=>q('[data-size-'+name+']').textContent=v.dims[i]);
      q('[data-size-photo]').src=v.image;q('[data-size-photo]').alt=v.title+' product detail.';
      q('[data-each]').textContent=money(v.price-off(v,quantity));q('[data-final-price]').textContent=money(v.price-off(v,quantity));
      q('[data-compare]').hidden=!(v.compare>v.price);q('[data-compare]').textContent=money(v.compare);
      for (const qty of [1,2,3]) {
        q(`[data-tier-each="${qty}"]`).replaceChildren(document.createTextNode(money(v.price-off(v,qty))+' '),Object.assign(document.createElement('small'),{textContent:'each'}));
        q(`[data-tier-total="${qty}"]`).textContent=money((v.price-off(v,qty))*qty)+' total';
        if(qty>1){q(`[data-tier-strike="${qty}"]`).textContent=money(v.price*qty);q(`[name="story_bundle"][value="${qty}"]`).closest('label').querySelector('em').textContent='SAVE '+money(off(v,qty)*qty);}
      }
      q('[data-total]').textContent=money(total);
      q('[data-savings]').hidden=quantity===1;
      q('[data-savings]').textContent=`Save ${money(chosen().reduce((n,x)=>n+off(x || v,quantity),0))}. Your bundle discount is added at checkout.`;
      q('[data-pair-each]').textContent=money(v.price-off(v,2))+' each';
      q('[data-pair-total]').textContent=money((v.price-off(v,2))*2)+' total';
      q('[data-pair-strike]').textContent=money(v.price*2);
      q('[data-story-form] [name="id"]').value=selection[0] || '';
      q('[data-story-form] [name="quantity"]').value=quantity;
      syncExpress();prepareExpress();
      q('[data-express]').hidden=busy||!allowed()||!expressReady;
      q('[data-main-photo]').src=v.image;q('[data-main-photo]').alt=v.title+' '+root.dataset.unit;
      q('[data-main-thumb]').src=v.image;q('[data-sticky-image]').src=v.image;
      q('[data-sticky-title]').textContent=quantity===1?flowerName(v):chosen().filter(Boolean).length+' of '+quantity+' chosen';
      q('[data-sticky-total]').textContent=money(total);
      const label=busy?'Adding...':launchHold?'Product preview':missing()>=0?'Choose item '+(missing()+1):allowed()?'Buy Now':'Check availability';
      q('[data-buy-label]').textContent=label;
      for(const s of ['[data-buy]','[data-add]','[data-sticky-buy]'])q(s).disabled=busy||!allowed();
      q('[data-sticky-buy]').textContent=label+' \u2192';
      history.replaceState({...history.state,tenloveFinds:{version:2,product:root.dataset.product,quantity,selection:[...selection],activeSlot}},'');
    };
    all('[name="story_variant"]').forEach(input=>input.addEventListener('change',()=>{
      if(busy)return;selection[activeSlot]=find(input.value).id;q('[data-error]').hidden=true;
      const url=new URL(location.href);url.searchParams.set('variant',String(selection[0]));history.replaceState(history.state,'',url);update();go(0);
    }));
    all('[name="story_bundle"]').forEach(input=>input.addEventListener('change',()=>{
      if(busy)return;quantity=Number(input.value);
      if(variants.length===1)selection=Array.from({length:3},(_,i)=>i<quantity?initial.id:null);
      activeSlot=Math.max(0,missing());q('[data-error]').hidden=true;update();
    }));
    all('[data-kit-slot]').forEach(button=>button.addEventListener('click',()=>{
      if(busy)return;activeSlot=Number(button.dataset.kitSlot)-1;q('[data-error]').hidden=true;update();
    }));
    const add = async checkout => {
      if(busy||!allowed())return;
      busy=true;q('[data-error]').hidden=true;update();
      const counts=new Map();for(const v of chosen())counts.set(v.id,(counts.get(v.id)||0)+1);
      const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),20000);
      try {
        const response=await fetch(`${route}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},signal:controller.signal,body:JSON.stringify({items:[...counts].map(([id,quantity])=>({id,quantity}))})});
        const data=await response.json();if(!response.ok)throw Error(data.description||'Please check your selection and try again.');
        const destination=route+(checkout?'checkout':'cart');
        location.assign(bundleCode()?`${route}discount/${bundleCode()}?redirect=${encodeURIComponent(destination)}`:destination);
      } catch(error) {
        q('[data-error]').textContent=error.name==='AbortError'||error instanceof TypeError?'We could not confirm your bag update. Please check your bag before trying again.':error.message;
        q('[data-error]').hidden=false;busy=false;update();
      } finally {clearTimeout(timeout);}
    };
    q('[data-story-form]').addEventListener('submit',event=>{event.preventDefault();event.stopImmediatePropagation();add(true);},true);
    q('[data-add]').addEventListener('click',()=>add(false));q('[data-sticky-buy]').addEventListener('click',()=>add(true));
    window.addEventListener('pageshow',()=>{busy=false;expressTarget=undefined;update();});
    const track=q('[data-track]'),slides=all('.tlr-slide'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
    let slide=0;
    const go=index=>{slide=Math.max(0,Math.min(slides.length-1,index));track.scrollTo({left:slide*track.clientWidth,behavior:reduced.matches?'instant':'smooth'});};
    track.addEventListener('scroll',()=>{slide=Math.round(track.scrollLeft/track.clientWidth);all('[data-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.thumb)===slide)));syncVideo();},{passive:true});
    all('[data-thumb]').forEach(b=>b.addEventListener('click',()=>go(Number(b.dataset.thumb))));
    track.addEventListener('keydown',event=>{if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();go(slide+(event.key==='ArrowRight'?1:-1));}});
    const video=q('[data-motion]');let videoVisible=false;
    const syncVideo=()=>{if(videoVisible&&slide===1){const source=video.querySelector('source');if(!source.src){source.src=source.dataset.src;video.load();}if(!reduced.matches)video.play().catch(()=>{});}else video.pause();};
    const videoObserver=new IntersectionObserver(entries=>{videoVisible=entries[0].isIntersecting;syncVideo();},{threshold:.25});videoObserver.observe(track);
    const gif=q('[data-gif]'),poster=gif.src;let gifVisible=false;
    const syncGif=()=>{const src=gifVisible&&!reduced.matches?gif.dataset.gifSrc:poster;if(gif.src!==src)gif.src=src;};
    const gifObserver=new IntersectionObserver(entries=>{gifVisible=entries[0].isIntersecting;syncGif();},{rootMargin:'80px'});gifObserver.observe(gif);
    reduced.addEventListener('change',()=>{syncGif();syncVideo();});
    const resizeObserver=new ResizeObserver(()=>track.scrollTo({left:slide*track.clientWidth,behavior:'instant'}));resizeObserver.observe(track);
    const stickyObserver=new IntersectionObserver(entries=>{q('[data-sticky]').hidden=entries[0].boundingClientRect.top>=0;});stickyObserver.observe(q('[data-price-anchor]'));
    const dialog=q('[data-lightbox]');
    all('[data-enlarge]').forEach(button=>button.addEventListener('click',()=>{const img=button.querySelector('img');q('[data-lightbox-image]').src=img.src;q('[data-lightbox-image]').alt=img.alt;q('[data-lightbox-caption]').textContent=img.alt;dialog.showModal();}));
    q('[data-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){video.pause();videoObserver.disconnect();gifObserver.disconnect();resizeObserver.disconnect();stickyObserver.disconnect();}});
    update();
  };
  document.querySelectorAll('[data-story]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-story]').forEach(init));
})();

(() => {
  const init = root => {
    if (root.dataset.animationInitialized) return;
    root.dataset.animationInitialized = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let overlay, timer;
    const clear = () => { clearTimeout(timer); overlay?.remove(); overlay = null; };
    const play = () => {
      clear();
      if (reduced.matches) return;
      overlay = document.createElement('div');
      overlay.className = 'tls-particles'; overlay.setAttribute('aria-hidden','true');
      const count = innerWidth < 850 ? 12 : 18;
      const motifs = root.dataset.animation === 'numbers' ? ['1','2','3','+'] : root.dataset.animation === 'multiply' ? ['×','÷','='] : root.dataset.animation === 'music' ? ['♪','♫'] : root.dataset.animation === 'stars' ? ['✦','✧'] : [];
      for (let i = 0; i < count; i++) {
        const part = document.createElement('span'); part.className = 'tls-particle';
        if (motifs.length) part.textContent = motifs[i % motifs.length];
        part.style.cssText = `--left:${(i+Math.random())/count*100}%;--size:${10+Math.random()*8}px;--drift:${(Math.random()-.5)*120}px;--turn:${120+Math.random()*300}deg;--duration:${5+Math.random()}s;--delay:${Math.random()*1.5}s`;
        overlay.append(part);
      }
      root.append(overlay); timer = setTimeout(clear,7800);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',play,{once:true}); else play();
    window.addEventListener('pageshow',event=>{if(event.persisted)play();});
    window.addEventListener('pagehide',clear);
    reduced.addEventListener('change',event=>{if(event.matches)clear();});
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))clear();});
  };
  document.querySelectorAll('[data-story]').forEach(init);
})();
